import Modal from "../ui/Modal";
import { useCostCalculator } from "../CostCalculator/useCostCalculator";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export default function CostCalculatorModal({ isOpen, onClose }: Props) {
  const {
    form,
    loading,
    success,
    handleChange,
    submit,
  } = useCostCalculator();
    const lookupOptions = [1000,2000, 5000,7000,10000, 15000,20000,30000,50000,75000,100000, 200000, ];
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Cost Calculator">
      <form
        className="mx-auto max-w-4xl grid grid-cols-2 gap-4 items-start"
        onSubmit={(e) => {
          e.preventDefault();
          submit(true);
        }}
      >
        {/* Provider */}
        <div className="flex flex-col">
          <label className="text-sm font-medium mb-1 min-h-[2.5rem] leading-snug">
            Do you currently have a provider for lookups?
          </label>
          <select
            name="HasProvider"
            value={String(form.HasProvider)}
            onChange={handleChange}
            className="w-full rounded-md border px-3 py-2 text-sm"
          >
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
        </div>

        {/* Provider price */}
        <div className="flex flex-col">
          <label className="text-sm font-medium mb-1 min-h-[2.5rem] leading-snug">
            Current provider’s price (p per lookup)
          </label>
          <input
            name="CurrentProviderPrice"
            type="number"
            step="0.01"
            value={form.CurrentProviderPrice ?? ""}
            onChange={handleChange}
            className="w-full rounded-md border px-3 py-2 text-sm"
          />
        </div>


        {/* Lookups */}
        <div className="flex flex-col">
        <label className="text-sm font-medium mb-1 min-h-[2.5rem] leading-snug">
            Estimated number of lookups per month
        </label>

        <select
            name="EstimatedMontlyLookups"
            value={form.EstimatedMontlyLookups ?? ""}
            onChange={(e) => {
            handleChange(e);
            submit();
            }}
            className="w-full rounded-md border px-3 py-2 text-sm"
        >
            {lookupOptions.map((option) => (
            <option key={option} value={option}>
                {option.toLocaleString()}
            </option>
            ))}
        </select>
        </div>


        {/* Renewal date */}
        <div className="flex flex-col">
          <label className="text-sm font-medium mb-1 min-h-[2.5rem] leading-snug">
            Provider renewal date
          </label>
          <input
            type="date"
            name="CurrentProviderRenewalDate"
            value={form.CurrentProviderRenewalDate ?? ""}
            onChange={(e) => {
              handleChange(e);
              submit();
            }}
            className="w-full rounded-md border px-3 py-2 text-sm"
          />
        </div>

        {/* Savings */}
        <div className="col-span-2 rounded-md bg-gray-50 p-4 text-sm">
          <div className="mb-2 font-semibold">
            Total estimated saving with{" "}
            <span className="font-bold">Enhanced Address Finder</span>
          </div>

          <div className="grid grid-cols-2 gap-y-1 gap-x-8">
            <span>Estimated cost with current provider</span>
            <span className="text-right">
              £ {form.CurrentProvidersEstimatedCost?.toFixed(2) ?? "0.00"}
            </span>

            <span>Our price</span>
            <span className="text-right">
              £ {form.OurPrice?.toFixed(2) ?? "0.00"}
            </span>

            <span className="font-medium text-green-700">
              Saving per month
            </span>
            <span className="text-right font-medium text-green-700">
              £ {form.TotalEstimatedSavingsWithEAFPerMonth?.toFixed(2) ?? "0.00"}
            </span>

            <span className="font-medium text-green-700">
              Saving per annum
            </span>
            <span className="text-right font-medium text-green-700">
              £ {form.TotalEstimatedSavingsWithEAFPerAnnum?.toFixed(2) ?? "0.00"}
            </span>
          </div>
        </div>

        {/* Email */}
        <div className="flex flex-col">
          <label className="text-sm font-medium mb-1">
            Your email address
          </label>
          <input
            name="EmailAddress"
            type="email"
            value={form.EmailAddress ?? ""}
            onChange={(e) => {
              handleChange(e);
              submit();
            }}
            className="w-full rounded-md border px-3 py-2 text-sm"
          />
        </div>

        {/* Phone */}
        <div className="flex flex-col">
          <label className="text-sm font-medium mb-1">
            Your phone number
          </label>
          <input
            name="PhoneNumber"
            value={form.PhoneNumber ?? ""}
            onChange={(e) => {
              handleChange(e);
              submit();
            }}
            className="w-full rounded-md border px-3 py-2 text-sm"
          />
        </div>

        {/* Success */}
        {success && (
          <div className="col-span-2 text-center text-sm text-green-600">
            Thank you for registering your interest! We will contact you soon.
          </div>
        )}

        {/* Submit */}
        {!success && (
          <div className="col-span-2">
            <button
              type="submit"
              disabled={loading}
              className="w-full rounded-md bg-blue-600 py-2.5 text-sm font-semibold text-white"
            >
              {loading ? "Saving..." : "Register Interest"}
            </button>
          </div>
        )}
      </form>
    </Modal>
  );
}
